"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getPageById_1 = __importDefault(require("./getPageById"));
function getObjectIdContextDefault(ctx) {
    const { pathname, asPath = pathname, query } = ctx;
    let { id } = query;
    let objectId = '';
    let objectType = '';
    if (!id && asPath) {
        const execResult = /\/([a-z]-\d+)(\/|$)/.exec(asPath);
        if (execResult) {
            id = execResult[1];
        }
    }
    if (id) {
        const page = (0, getPageById_1.default)(id);
        if (page) {
            objectId = page.objectId;
            objectType = page.objectType;
        }
    }
    return { id, objectId, objectType };
}
exports.default = getObjectIdContextDefault;
//# sourceMappingURL=getObjectIdContextDefault.js.map